import { ElementProps } from '@/components/sections/builder/types';
import { AnnouncementElementDataType } from '@/components/sections/builder/elements/header/announcement/types';
import InputSlider from '@/components/sections/builder/settings/input-slider';
import PaddingSetting from '@/components/sections/builder/settings/padding-setting';
import { Checkbox } from '@/components/ui/checkbox';
import { useBuilderStore } from '@/stores/builder';
import { shallow } from 'zustand/shallow';
import SchemeSetting from '@/components/sections/builder/settings/scheme-setting';
import InputTab from '@/components/sections/builder/settings/input-tab';

export default function ElementSetting({ element }: ElementProps) {
  const builder = useBuilderStore(
    (state) => ({
      setElementData: state.setElementData,
      clearSelected: state.clearSelected,
    }),
    shallow
  );

  const data = element.data as AnnouncementElementDataType;

  return (
    <div>
      <div className='mb-2 mt-4 font-bold'>Color scheme</div>
      <SchemeSetting
        value={data.colorScheme}
        onChange={(theme) => {
          builder.setElementData(element.id, {
            colorScheme: theme,
          });
        }}
      />
      <div className='mb-4 mt-1 text-xs'>
        To edit all your theme&apos;s colors, go to your color theme settings.
      </div>
      <div className='mb-4 font-bold'>Setting</div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='separator'
          className='mx-2'
          checked={data.separator}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              separator: !!checked,
            });
          }}
        />
        <label htmlFor='separator'>Show separator line</label>
      </div>

      <div className='mb-2 mt-4 font-bold'>Social media icons</div>
      <div>To display your social media accounts, link them in your theme settings.</div>
      <div className='mt-4 flex gap-x-1'>
        <Checkbox
          id='showSocialMediaIcon'
          className='mx-2'
          checked={data.showSocialMediaIcon}
          onCheckedChange={(checked) => {
            builder.setElementData(element.id, {
              showSocialMediaIcon: !!checked,
            });
          }}
        />
        <label htmlFor='showSocialMediaIcon'>Show icons on desktop</label>
      </div>
      <div className='mb-2 mt-4 font-bold'>Change Every</div>
      <div className='flex items-center'>
        <div className='w-full'>
          <InputSlider
            max={10}
            value={data.changeEvery || 0}
            onChange={(val) => {
              builder.setElementData(element.id, {
                changeEvery: val,
              });
            }}
          />
        </div>
      </div>
      <PaddingSetting
        value={data.padding}
        onChange={(v) =>
          builder.setElementData(element.id, {
            padding: v,
          })
        }
      />
      <div className='my-4 font-bold'>Content Alignment</div>
      <InputTab
        defaultValue={data.contentAlign}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Center', value: 'center' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { contentAlign: v })}
      />
      <div className='my-4 font-bold'>Social Icon Alignment</div>
      <InputTab
        grid={2}
        defaultValue={data.socialIconAlign}
        options={[
          { label: 'Left', value: 'left' },
          { label: 'Right', value: 'right' },
        ]}
        onChange={(v) => builder.setElementData(element.id, { socialIconAlign: v })}
      />
    </div>
  );
}
